import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Crear tu primera pieza en menos de 24 horas', 'Seguir un proceso claro sin perderte', 'Dejar de depender de tutoriales confusos', 'Tener ideas infinitas para tejer', 'Convertir esto en una fuente de ingresos desde casa'];
  return <section className="w-full py-16 px-4 bg-cream" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-center text-gray-900 mb-12" data-id="element-3">
          Con este método vas a poder:
        </h2>

        <div className="space-y-4" data-id="element-4">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 p-5 bg-white border-l-4 border-success rounded-r-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-5">
              <CheckCircleIcon className="w-7 h-7 text-success flex-shrink-0 mt-1" aria-hidden="true" data-id="element-6" />
              <p className="font-body text-lg md:text-xl text-gray-800 font-medium" data-id="element-7">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}